export default "__VITE_ASSET__98049b65__"